import React, { useEffect } from 'react';
import PartnerLogos from 'Comps/ForRestaurants/PartnerLogos';
import { createDerivedStateFromErrorLogger } from 'Utils/log';
import CallMeForm from 'Comps/ForRestaurants/CallMeForm';
import ReservationTier from 'Comps/ForRestaurants/tiers/ReservationTier';
var reservationPlans = [
    { amount: 75, price: 100, label: 'S', history: 'miesiąc wstecz' },
    {
        amount: 200,
        price: 200,
        label: 'M',
        featuredText: 'najczęściej wybierany!',
        history: '3 miesiące wstecz',
    },
    { amount: 'UNLIMITED', price: 350, label: 'L', history: 'bez limitów' },
];
var ReservationsOffer = function () {
    useEffect(function () {
        var _a;
        (_a = document.querySelector('.until-react-spinner')) === null || _a === void 0 ? void 0 : _a.remove();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(CallMeForm, { id: "call-me", title: "Masz pytania i chcesz porozmawia\u0107 z \u017Cyw\u0105 osob\u0105?", text: "Podaj numer telefonu - oddzwonimy w ci\u0105gu godziny!" }),
        React.createElement("section", { className: "tiers" },
            React.createElement("h2", { className: "fr-title w-100 mt-5 mb-4 text-center" }, "Ile to kosztuje?"),
            reservationPlans.map(function (plan) { return (React.createElement(ReservationTier, { key: plan.label, bestTierLabel: plan.featuredText, plan: plan, plans: reservationPlans },
                React.createElement("a", { href: "#start-now", className: "js-scroll-trigger for-restaurants-cta-btn mt-3" }, "Wybierz"))); })),
        React.createElement("section", { className: "partners" },
            React.createElement(PartnerLogos, { text: "Oni ju\u017C przyjmuj\u0105 rezerwacje online", type: "reservations" })),
        React.createElement(CallMeForm, { id: "start-now", title: "Zacznij ju\u017C teraz", text: "Zostaw numer telefonu - oddzwonimy w ci\u0105gu godziny i om\u00F3wimy szczeg\u00F3\u0142y!" }),
        React.createElement("section", { className: "cta-your-time mt-5" },
            React.createElement("div", { className: "cta-section__content" },
                React.createElement("h2", { className: "fr-title" }, "Teraz Twoja kolej na przyjmowanie rezerwacji on-line"),
                React.createElement("a", { href: "#call-me", className: "js-scroll-trigger for-restaurants-cta-btn" }, "Wypr\u00F3buj teraz"))),
        React.createElement("section", { className: "fr-note" },
            React.createElement("p", { className: "container" }, "*Je\u015Bli system nie spe\u0142ni oczekiwa\u0144 gwarantujemy zwrot koszt\u00F3w subskrypcji poniesionych w okresie pr\u00F3bnym."))));
};
ReservationsOffer.getDerivedStateFromError =
    createDerivedStateFromErrorLogger('ReservationsOffer');
export default ReservationsOffer;
